declare var $:any;
import {action, computed, observable} from "mobx";
import {GET_QUERY} from "utils";
import * as moment from 'moment-timezone';
import {ISolution} from "./SolutionDataSource";

interface IMainStageEvent {
  _id:string;
  title: string;
  navTitle: string;
  description: string;
  icon:string;
  backgroundImage:string;
  preLoadTS: Date;
  presentationStartTS: Date;
  presentationEndTS: Date;
  qaStartTS: Date;
  qaEndTS: Date;
  presenter: any;
  videoId:string;
  streamingService:string;
}

export class MainStageEvent implements IMainStageEvent {
  _id:string;
  title: string;
  navTitle: string;
  description: string;
  icon:string;
  preLoadTS: Date;
  presentationStartTS: Date;
  presentationEndTS: Date;
  qaStartTS: Date;
  qaEndTS: Date;
  presenter: any;
  backgroundImage: string;

  @observable isNext:boolean;
  @observable isLive:boolean;
  @observable status:string;

  @observable videoId:string;
  @observable streamingService:string;

  @computed get isZoom() {
    return 'zoom'===this.streamingService;
  }

  @computed get isVimeo() {
    return 'vimeo'===this.streamingService;
  }

  @computed get liveStreamLink() {
    if('zoom'===this.streamingService) {
      return "https://us02web.zoom.us/j/"+this.videoId;
    } else {
      //return "https://player.vimeo.com/video/"+this.videoId;
      return "https://vimeo.com/event/"+this.videoId+"/embed";
    }
  }

  constructor(json:IMainStageEvent) {
    this._id = json._id;
    this.title = json.title;
    this.navTitle = json.navTitle;
    this.description = json.description;
    this.icon = json.icon;
    this.preLoadTS = json.preLoadTS;
    this.presentationStartTS = json.presentationStartTS;
    this.presentationEndTS = json.presentationEndTS;
    this.qaStartTS = json.qaStartTS;
    this.qaEndTS = json.qaEndTS;
    this.streamingService = json.streamingService;
    this.videoId = json.videoId;
    this.presenter = json.presenter;
    this.isNext = false;
    this.isLive = false;
    this.status = '';
    this.backgroundImage = json.backgroundImage;
  }
}


interface IStatusUpdate {
  nextId:string;
  liveId:string;
  schedule:{[id:string]:{ status:string, videoId:string, streamingService:string, }};
  statusMessage:{
    message:string;
    level:string;
    timestamp:string;
  }
}

const UPDATE_FREQUENCY = 10 * 1000;

class _MainStageData {
  @observable solutionId:string;
  @observable mainStageEvents:MainStageEvent[] = [];
  @observable updateState:'pending'|'error'|'updated' = 'pending';
  @observable lastSuccessfulUpdate:Date;
  @observable statusMessage:string;
  @observable statusLevel:string;
  @observable statusTimestamp:moment.Moment|null;

  @action clear = () => {
    this.mainStageEvents = [];
  }

  scheduleAnUpdate = (ms?:number) => {
    if(this.mainStageEvents && this.mainStageEvents.length>0) {
      if(ms) {
        setTimeout(this.fetchUpdate, ms);
      } else {
        this.fetchUpdate();
      }
    }
  }

  @action
  fetchUpdate = () => {
    this.updateState = 'pending';

    $.ajax(GET_QUERY('/mainStageEventsStatus/'+this.solutionId))
      .done((statusUpdate:IStatusUpdate)=>{
        this.update(statusUpdate)
        this.scheduleAnUpdate(UPDATE_FREQUENCY);
        this.updateState = 'updated';
      })
      .fail(() => {
        this.updateState = 'error';
        this.scheduleAnUpdate(UPDATE_FREQUENCY);
      });
  }

  @action load(solution:ISolution, mainStageEvents:IMainStageEvent[]) {
    this.solutionId = solution._id;
    this.mainStageEvents = [];
    mainStageEvents.forEach((json:IMainStageEvent)=>{
      this.mainStageEvents.push(new MainStageEvent(json));
    })
    this.scheduleAnUpdate();
  }

  @action update = (mainStageUpdate:IStatusUpdate) =>  {
    this.mainStageEvents.forEach((event)=>{
      event.isNext = mainStageUpdate.nextId===event._id;
      event.isLive = mainStageUpdate.liveId===event._id;
      const scheduleInfo = mainStageUpdate.schedule[event._id];
      if(scheduleInfo) {
        event.status = scheduleInfo.status;
        event.videoId = scheduleInfo.videoId;
        event.streamingService = scheduleInfo.streamingService;
      }
    });
    this.statusMessage = mainStageUpdate.statusMessage.message;
    this.statusLevel = mainStageUpdate.statusMessage.level;
    try {
      this.statusTimestamp = mainStageUpdate.statusMessage.timestamp ? moment(mainStageUpdate.statusMessage.timestamp) : null;
    } catch(error) {
      console.log(error)
      this.statusTimestamp = null;
    }
  }

  @computed get mainStageEventsEnabled() {
    return this.mainStageEvents && this.mainStageEvents.length>0;
  }
  @computed get liveMainStageEvent() {
    return this.mainStageEvents.find((e)=>e.isLive);
  }
  @computed get nextMainStageEvent() {
    return this.mainStageEvents.find((e)=>e.isNext);
  }


}



export const MainStageData = new _MainStageData();
